import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { ChangePasswordPage } from "@/modules/profile";
import { requireAuth } from "@/utils";

export const Route = createFileRoute("/settings/change-password")({
  beforeLoad: requireAuth,
  component: () => (
    <>
      <DocumentTitle
        title="Change Password"
        description="Update your LAMPU Seller Center account password."
      />
      <ChangePasswordPage />
    </>
  )
});
